import { compose, withProps } from 'recompose'
import mapValues from 'lodash/mapValues'
import some from 'lodash/some'
import withType from 'components/common/hoc/withType'
import extractArrayValues from 'helpers/extract-array-values'
import BOTTrailerTireLines from './BOTTrailerTireLines'
import GridTireLines from './components/GridTireLines'
import FlexTireLines from './components/FlexTireLines'

const withTrailerTireLineDetails = withProps(({ trailerTireLineDetails }) => ({
  trailerTireLineDetails: mapValues(
    trailerTireLineDetails,
    tires => tires.map(
      ({ attributes: { tireType, ...attributes }}) => ({ tireType, ...extractArrayValues(attributes) })
    )
  )
}))

const withLayoutProps = withProps(({ trailerTireLineDetails }) => {
  const hasManyBrands = Object.keys(trailerTireLineDetails).length > 2
  const hasManyTires = some(trailerTireLineDetails, tires => tires.length > 1)

  const useFlex = !hasManyBrands && !hasManyTires

  return {
    useFlex,
    TireLines: useFlex ? FlexTireLines : GridTireLines
  }
})

export default compose(
  withType({ type: 'BOTTrailerTireLines' }),
  withTrailerTireLineDetails,
  withLayoutProps
)(BOTTrailerTireLines)
